/**
 * Environment Configuration
 * Хранит переменные окружения для Frontend
 */
const isBrowser = typeof window !== 'undefined';

export const Environment = {
  // API endpoints (без trailing slash, base URL без /api — пути в сервисах уже включают /api или /res)
  localApiURL: isBrowser ? 'http://localhost:8000' : 'http://backend:8000',
  
  // Feature flags
  enableAnalytics: true,
  enableAIDescription: true,
  
  // App config
  appName: 'MKVM Platform',
  version: '0.2.22',
};

export type Environment = typeof Environment;
